import controller from '../../../../Resources/Scripts/_Shared/controller';

const DISMISSED_KEY = 'aimopark_portalbanner_dismissed';
const RESET_COOKIE = 'AimoPortalBannerReset';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

function consumeResetCookie() {
  if (!getCookie(RESET_COOKIE))
      return;

  // A logout just happened (see CommonController.Logout) — reset the dismissed flag.
  localStorage.removeItem(DISMISSED_KEY);
  document.cookie = `${RESET_COOKIE}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

function portalbanner(context) {
  const dismissButton = context.querySelector('.aimo-portal-banner__dismiss');

  function init() {
    consumeResetCookie();

    if (localStorage.getItem(DISMISSED_KEY))
        return;

    context.classList.add('aimo-portal-banner--visible');
    context.removeAttribute('aria-hidden');

    dismissButton.addEventListener('click', function(event) {
      localStorage.setItem(DISMISSED_KEY, '1');
      context.classList.remove('aimo-portal-banner--visible');
      context.setAttribute('aria-hidden', 'true');
      event.preventDefault();
    });
  }

  return {
    init
  };
}

controller.add('portal-banner', portalbanner);
